'use strict';

exports.__esModule = true;
exports.replaceUrlQueryFromAction = replaceUrlQueryFromAction;
exports.pushUrlQueryFromAction = pushUrlQueryFromAction;
exports.replaceInUrlQueryFromAction = replaceInUrlQueryFromAction;
exports.pushInUrlQueryFromAction = pushInUrlQueryFromAction;

var _updateUrlQuery = require('../updateUrlQuery');

function replaceUrlQueryFromAction(action, location) {
  var encodedQuery = action.payload.encodedQuery;

  (0, _updateUrlQuery.replaceUrlQuery)(encodedQuery, location);
}

function pushUrlQueryFromAction(action, location) {
  var encodedQuery = action.payload.encodedQuery;

  (0, _updateUrlQuery.pushUrlQuery)(encodedQuery, location);
}

function replaceInUrlQueryFromAction(action, location) {
  var _action$payload = action.payload;
  var queryParam = _action$payload.queryParam;
  var encodedValue = _action$payload.encodedValue;

  (0, _updateUrlQuery.replaceInUrlQuery)(queryParam, encodedValue, location);
}

function pushInUrlQueryFromAction(action, location) {
  var _action$payload2 = action.payload;
  var queryParam = _action$payload2.queryParam;
  var encodedValue = _action$payload2.encodedValue;

  (0, _updateUrlQuery.pushInUrlQuery)(queryParam, encodedValue, location);
}


//////////////////
// WEBPACK FOOTER
// ./~/react-url-query/lib/redux/updateUrlQueryFromAction.js
// module id = 116
// module chunks = 0